<template>
  <b-modal
    modal-class="client-form-modal"
    body-class="bg-extra-light-gray"
    footer-class="bg-extra-light-gray"
    v-model="editorShown"
    :title="''"
    @ok="onEdit()"
    @close="onCancel()"
    size="md"
    centered
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <template v-slot:modal-header>
      <div
        class="w-100 d-flex flex-row justify-content-between align-items-center"
      >
        <h5 class="modal-title">Add new card</h5>
        <div class="d-flex align-items-center">
          <button
            type="button"
            aria-label="Close"
            class="close text-white"
            @click="
              () => {
                forDemographics ? (editorShown = false) : $emit('onModify');
              }
            "
          >
            ×
          </button>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <b-button
        variant="secondary"
        @click="
          () => {
            forDemographics ? (editorShown = false) : $emit('onModify');
          }
        "
      >
        Cancel
      </b-button>
      <b-button variant="primary" @click="submitCard()">
        Save
      </b-button>
    </template>
    <div class="new-card">
      <b-row>
        <b-col>
          <b-form-group
            :state="formErrors.cardNumber.length == 0 ? null : false"
            :invalid-feedback="formErrors.cardNumber.join(', ')"
          >
            <template v-slot:label>
              Card number <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.cardNumber"
              trim
              :state="formErrors.cardNumber.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            :state="formErrors.nameOnCard.length == 0 ? null : false"
            :invalid-feedback="formErrors.nameOnCard.join(', ')"
          >
            <template v-slot:label>
              Name on card <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.nameOnCard"
              trim
              :state="formErrors.nameOnCard.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Expiration date"
            :state="formErrors.expirationDate.length === 0 ? null : false"
            :invalid-feedback="formErrors.expirationDate.join(', ')"
          >
            <template v-slot:label>
              Expiration date <span class="text-danger">*</span>
            </template>
            <div class="d-flex">
              <v-select
                style="width:80px"
                v-model="form.expMonth"
                :options="months"
                :clearable="false"
                :state="formErrors.expirationDate.length === 0 ? null : false"
              ></v-select>
              <v-select
                style="width:100px"
                class="ml-2"
                v-model="form.expYear"
                :options="years"
                :clearable="false"
                :state="formErrors.expirationDate.length === 0 ? null : false"
              ></v-select>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="bg-extra-light-gray rounded section-title">
        <b class="mb-2">Billing Address:</b>
      </div>
      <b-row>
        <b-col>
          <b-form-group
            :state="formErrors.street1.length == 0 ? null : false"
            :invalid-feedback="formErrors.street1.join(', ')"
          >
            <template v-slot:label>
              Address <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.street1"
              trim
              :state="formErrors.street1.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            :state="formErrors.city.length == 0 ? null : false"
            :invalid-feedback="formErrors.city.join(', ')"
          >
            <template v-slot:label>
              City <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.city"
              trim
              :state="formErrors.city.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="State"
            :state="formErrors.stateId.length == 0 ? null : false"
            :invalid-feedback="formErrors.stateId.join(', ')"
          >
            <template v-slot:label>
              State <span class="text-danger">*</span>
            </template>
            <v-select v-model="form.stateId" :options="states"></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group
            :state="formErrors.zipCode.length == 0 ? null : false"
            :invalid-feedback="formErrors.zipCode.join(', ')"
          >
            <template v-slot:label>
              Zip Code <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.zipCode"
              trim
              :state="formErrors.zipCode.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <template v-slot:label>
              Comments
            </template>
            <b-form-input
              v-model="comments"
              trim
              placeholder="i.e ”Mom’s Card”"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { validateRequired, validateZipcode } from "../../helpers/validation";
import payaServer from "../../server/paya";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "PatientPaymentMethodAddModal",
  props: ["patientId", "forDemographics"],
  data() {
    return {
      form: {
        nameOnCard: "",
        cardNumber: "",
        expirationDate: "",
        expMonth: "01",
        expYear: "",
        zipCode: "",
        stateId: "",
        city: "",
        street1: ""
      },
      comments: "",
      formErrors: {
        nameOnCard: [],
        cardNumber: [],
        expirationDate: [],
        street1: [],
        city: [],
        zipCode: [],
        stateId: []
      },
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ],
      years: []
    };
  },
  mounted() {
    this.generateNext10Years();
    this.form.expYear = this.years[0];
  },
  methods: {
    generateNext10Years() {
      var currentYear = moment().year();

      for (var i = 0; i < 10; i++) {
        this.years.push((currentYear + i).toString());
      }
    },
    validateFormSubmit() {
      let withoutErrors = true;

      this.formErrors.nameOnCard = [];
      if (!validateRequired(this.form.nameOnCard)) {
        this.formErrors.nameOnCard.push("This field is required.");
        withoutErrors = false;
      }
      this.formErrors.cardNumber = [];
      if (!validateRequired(this.form.cardNumber)) {
        this.formErrors.cardNumber.push("This field is required.");
        withoutErrors = false;
      } else if (
        this.form.cardNumber.replace(" ", "").length != 16 &&
        this.form.cardNumber.replace(" ", "").length != 15
      ) {
        this.formErrors.cardNumber.push("Card number is not correct.");
        withoutErrors = false;
      }

      this.formErrors.expirationDate = [];
      const currentYear = moment().year();
      const currentMonth = moment().month() + 1;
      if (
        parseInt(this.form.expYear) <= currentYear &&
        currentMonth > parseInt(this.form.expMonth)
      ) {
        this.formErrors.expirationDate.push("This card is expired.");
        withoutErrors = false;
      }

      this.formErrors.street1 = [];
      if (!validateRequired(this.form.street1)) {
        this.formErrors.street1.push("This field is required.");
        withoutErrors = false;
      }

      this.formErrors.city = [];
      if (!validateRequired(this.form.city)) {
        this.formErrors.city.push("This field is required.");
        withoutErrors = false;
      }

      this.formErrors.zipCode = [];
      if (!validateRequired(this.form.zipCode)) {
        this.formErrors.zipCode.push("This field is required.");
        withoutErrors = false;
      }
      if (this.form.zipCode && !validateZipcode(this.form.zipCode)) {
        this.formErrors.zipCode.push(
          "This field must have a valid zipcode format."
        );
        withoutErrors = false;
      }

      this.formErrors.stateId = [];
      if (!validateRequired(this.form.stateId)) {
        this.formErrors.stateId.push("This field is required.");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    submitCard() {
      const result = this.validateFormSubmit();
      if (result && !this.forDemographics) {
        this.form.expirationDate =
          this.form.expMonth + this.form.expYear.slice(-2);

        payaServer
          .addPaymentMethod(this.patientId, {
            ...this.form,
            stateId: this.form.stateId.value,
            comments: this.comments
          })
          .then(async resp => {
            if (resp.isOk) {
              this.$emit("onModify");
            } else {
              this.$dialog.alert("Error: " + resp.errorMessage);
            }
          });
      } else if (result && this.forDemographics) {
        this.$emit("setPaymentInfo", {
          ...this.form,
          stateId: this.form.stateId.value,
          comments: this.comments
        });
        this.editorShown = false;
      }
    },
    cancel() {
      this.isNewCardVisible = false;
      this.clearForm();
    },
    clearForm() {
      this.form = {
        nameOnCard: "",
        cardNumber: "",
        expirationDate: "",
        expMonth: "",
        expYear: "",
        zipCode: "",
        stateId: "",
        city: "",
        street1: "",
        comments: ""
      };

      this.formErrors = {
        nameOnCard: [],
        cardNumber: [],
        street1: [],
        city: [],
        zipCode: [],
        stateId: []
      };

      this.form.expMonth = this.months[moment().month()];

      this.form.expYear = moment()
        .year()
        .toString();
    }
  },
  computed: {
    ...mapState("client", {
      states: state =>
        state.states.map(s => ({
          label: s.name,
          value: s.abbreviation
        }))
    }),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style></style>
